<script setup>
import { ref } from 'vue';
import Button from 'dashboard/components-next/button/Button.vue';
import HelpDrawer from './HelpDrawer.vue';
import { useProductTour } from 'dashboard/composables/useProductTour';

const props = defineProps({
  systemKey: { type: String, required: true },
  articleKey: { type: String, default: '' },
  beforeStart: { type: Function, default: null },
});

const isDrawerOpen = ref(false);
const { startTour } = useProductTour(props.systemKey);

const handleStartTour = async () => {
  await props.beforeStart?.();
  startTour({ markAsCompleted: false });
};
</script>

<template>
  <div
    class="inline-flex items-center gap-1 rounded-lg border border-n-brand/25 bg-n-brand/5 p-0.5 shadow-sm ring-1 ring-n-brand/10"
  >
    <Button
      v-tooltip.bottom="$t('CONTEXTUAL_HELP.START_TOUR')"
      icon="i-lucide-route"
      color="blue"
      size="sm"
      variant="faded"
      :aria-label="$t('CONTEXTUAL_HELP.START_TOUR')"
      @click="handleStartTour"
    />
    <Button
      v-tooltip.bottom="$t('CONTEXTUAL_HELP.OPEN_HELP')"
      icon="i-lucide-circle-help"
      color="blue"
      size="sm"
      variant="faded"
      :aria-label="$t('CONTEXTUAL_HELP.OPEN_HELP')"
      @click="isDrawerOpen = true"
    />
    <HelpDrawer
      :show="isDrawerOpen"
      :system-key="systemKey"
      :article-key="articleKey"
      @close="isDrawerOpen = false"
    />
  </div>
</template>
